<template>

  <b-container>
    <m-shopping-cart-1 class="mt-4 mb-4" :empty-cart-image="require('../assets/empty-cart.svg')"/>
  </b-container>
</template>

<script>
export default {
  name: "ShoppingCart",
}
</script>

<style scoped>
</style>